export default function BasicQuestionForm(props) {
  return (
    <div class="flex flex-col space-y-4">
      <div class="absolute top-0 left-0 -z-10 h-full w-full">
        <div
          class={`zoom-in-bg bg-g h-full w-full bg-cover bg-top`}
          style={{
            "background-image": `linear-gradient(to bottom, rgba(255, 255, 255, 0.0) 42%, rgba(0, 0, 0, 0.82)),url(${props.image})`,
          }}
        ></div>
      </div>
      <div class="flex flex-col space-y-3 p-4 text-center">
        {props.question}
      </div>
      <div class="p flex w-full flex-row space-x-2 p-2">
        <For each={props.buttons}>
          {(item) => (
            <button
              class="bg-main h-14 w-full rounded-4xl px-4 py-2 font-bold"
              onClick={[props.next, { id: props.id, button: item.id }]}
            >
              {item.text}
            </button>
          )}
        </For>
      </div>
    </div>
  );
}
